module.exports = __webpack_public_path__ + "static/media/top_jamaica.b6fae5e4.svg";